import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';

import React, { useEffect, useRef } from 'react';
import { SearchInput, SearchInputRef } from '@ui/general';

export const TextFilter: FilterComponent<string | undefined> = (props) => {
	const searchRef = useRef<SearchInputRef>(null);

	useEffect(() => {
		if (searchRef.current) {
			searchRef.current.setText(props.value ?? '');
		}
	}, [ props.value ]);

	const { format, id, label, onChange, placeholder, value } = props;

	return (
		<FilterComponent { ...props }>
			<SearchInput
				className='filter'
				defaultValue={ value }
				id={ getFilterId(id) }
				onChange={ (query = '') =>
					onChange({
						[ id ]: {
							format,
							value: query
						}
					}) }
				placeholder={ placeholder ?? PLACEHOLDERS_COPY.FILTER_BY(capitalize(label ?? '')) }
				ref={ searchRef } />
		</FilterComponent>
	);
};
